// 静态资源图片路径
export const IMG_URL = 'https://oss.igongwu.com/static/';
// api
export const API_URL = 'https://api.igongwu.com/admin-api/';